import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.set";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { serverRetentionByTier } from "@/api/dataAll/accountRetain";
import * as echarts from "echarts";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import retainAllList from './components/retainAllList.vue'; // 缓存key定义（只缓存筛选项）

var CACHE_KEY = {
  SCREEN: 'serverRoleRetain_screen' // 只缓存选中的筛选项

}; // 固定天数列表

var FIXED_DAYS = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 35, 40, 45, 50, 55, 60, 75, 90, 120];
export default {
  name: "serverRoleRetain",
  mixins: [tabulation, gmToolNewPage, gmTool],
  components: {
    retainAllList: retainAllList
  },
  data: function data() {
    return {
      more: true,
      value2: [],
      tableData: [],
      Dynamic: [],
      // 筛选项选中的列（和输入框无关）
      displayDynamicColumns: [],
      // 最终展示的列（输入框值优先）
      PrimitiveDy: this.generateFixedPrimitiveDy(),
      dates: [],
      datas: [],
      series: [],
      intReq: [],
      screen: [],
      cellStylekeys: ["rem"],
      isRollingList: [{
        label: this.$t('yes'),
        value: 1
      }, {
        label: this.$t('no'),
        value: 0
      }],
      characterList: [{
        label: this.$t('characterSword'),
        value: 1
      }, {
        label: this.$t('characterThunder'),
        value: 2
      }, {
        label: this.$t('characterIce'),
        value: 3
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })), {}, {
    // 解析用户输入的self_design_day为天数数组
    parsedDays: function parsedDays() {
      var _this$searchData$self;

      var input = ((_this$searchData$self = this.searchData.self_design_day) === null || _this$searchData$self === void 0 ? void 0 : _this$searchData$self.trim()) || '';
      if (!input) return [];
      var days = [];
      var parts = input.split(',');
      parts.forEach(function (part) {
        part = part.trim();

        if (part.includes('-')) {
          // 处理范围格式 1-5
          var _part$split$map = part.split('-').map(Number),
              _part$split$map2 = _slicedToArray(_part$split$map, 2),
              start = _part$split$map2[0],
              end = _part$split$map2[1];

          if (!isNaN(start) && !isNaN(end) && start <= end) {
            for (var i = start; i <= end; i++) {
              days.push(i);
            }
          }
        } else {
          // 处理单个数字 1
          var num = Number(part);

          if (!isNaN(num)) {
            days.push(num);
          }
        }
      }); // 去重并排序

      return _toConsumableArray(new Set(days)).sort(function (a, b) {
        return a - b;
      });
    },
    // 输入框对应的列（输入值优先）
    inputBasedColumns: function inputBasedColumns() {
      var _this = this;

      if (this.parsedDays.length === 0) return []; // 过滤出输入天数对应的PrimitiveDy项

      return this.PrimitiveDy.filter(function (item) {
        var day = Number(item.prop.replace('rem', ''));
        return _this.parsedDays.includes(day);
      });
    }
  }),
  created: function created() {
    // 初始化缓存恢复（只恢复筛选项）
    this.restoreFromCache();
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    // ========== 核心：生成固定的PrimitiveDy列表 ==========
    generateFixedPrimitiveDy: function generateFixedPrimitiveDy() {
      var _this2 = this;

      return FIXED_DAYS.map(function (day) {
        // 2天特殊处理
        if (day === 2) {
          return {
            desc: _this2.$t('nextDayAccountRetention'),
            label: "".concat(_this2.$t('nextDayRetentionShort'), ".").concat(_this2.$t('rrPrefix')).concat(day),
            prop: "rem2",
            tableText: "RRA2"
          };
        } // 其他天数通用格式


        return {
          desc: "",
          label: "".concat(_this2.$t('dayRetentionShort', {
            day: day
          }), ".").concat(_this2.$t('rrPrefix')).concat(day),
          prop: "rem".concat(day),
          tableText: "RR".concat(day)
        };
      });
    },
    // ========== 缓存相关方法（只处理筛选项） ==========
    // 保存选中状态到缓存
    saveScreenToCache: function saveScreenToCache() {
      if (this.screen.length > 0) {
        localStorage.setItem(CACHE_KEY.SCREEN, JSON.stringify(this.screen));
      }
    },
    // 从缓存恢复筛选项
    restoreFromCache: function restoreFromCache() {
      var _this3 = this;

      // 恢复选中的筛选项
      var cachedScreen = localStorage.getItem(CACHE_KEY.SCREEN);

      if (cachedScreen) {
        var screen = JSON.parse(cachedScreen); // 过滤：确保选中的筛选项都在固定列表中

        this.screen = screen.filter(function (prop) {
          return _this3.PrimitiveDy.some(function (item) {
            return item.prop === prop;
          });
        });
      } else {
        // 无缓存时默认全选
        this.screen = this.PrimitiveDy.map(function (item) {
          return item.prop;
        });
      } // 初始化显示的表头（筛选项选中的列）


      this.screenControls();
    },
    // 清空输入框时的处理（只清空值，不缓存）
    handleInputClear: function handleInputClear() {
      this.searchData.self_design_day = '';
    },
    // ========== 业务方法（核心：选中状态和输入框解耦，输入值优先） ==========
    getServer: function getServer() {
      var _this4 = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this4.serverList = res.data;
        }
      });
    },
    searchClickNs: function searchClickNs() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 重置表格和图表数据（准备重新请求）
                _this5.tableData = [];
                _this5.series = [];
                _this5.dates = [];
                _this5.displayDynamicColumns = [];
                _this5.reqLoading = true;
                _context.prev = 5;
                // 构建请求参数
                _this5.searchData.kind = 1;
                _this5.searchData.server_id = _this5.paramsData.server_id;
                _this5.searchData.character_id = _this5.paramsData.character_id;
                _this5.searchData.is_roll = _this5.paramsData.is_roll; // 核心：调用接口重新获取数据

                _context.next = 12;
                return _this5.searchClickPoints(serverRetentionByTier, 1);

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](5);
                console.error('搜索请求失败:', _context.t0);

              case 17:
                _context.prev = 17;
                _this5.reqLoading = false;
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 14, 17, 20]]);
      }))();
    },
    searchClick: function searchClick(lists) {
      var _this6 = this;

      var qres = JSON.parse(JSON.stringify(lists));
      var res = {
        data: {
          register_sum: 0,
          data: {},
          avgData: {},
          other: {
            register_num: {}
          }
        }
      };
      qres.forEach(function (i) {
        res.data.data = _objectSpread(_objectSpread({}, res.data.data), i.data);
        res.data.other.register_num = _objectSpread(_objectSpread({}, res.data.other.register_num), i.other.register_num);
        res.data.register_sum = res.data.register_sum + Number(i.register_sum);

        for (var k in i.avgData) {
          var nums = i.retain_pnum[i.searchdate.starttime][k] == '/' ? 0 : Number(i.retain_pnum[i.searchdate.starttime][k]);
          res.data.avgData[k] = !res.data.avgData[k] ? nums : res.data.avgData[k] + nums;
        }
      });

      for (var i in res.data.avgData) {
        res.data.avgData[i] = (res.data.register_sum ? (res.data.avgData[i] / res.data.register_sum * 100).toFixed(2) : 0) + '%';
      }

      this.timeInterval();
      this.series = [];
      this.dates = [];
      this.tableData = []; // ========== 核心逻辑：输入值优先，且不改变选中状态 ==========
      // 1. 确定最终展示的列（输入值优先）

      if (this.parsedDays.length > 0) {
        // 有输入值：展示输入值对应的列（不改变screen选中状态）
        this.displayDynamicColumns = this.inputBasedColumns;
      } else {
        // 无输入值：展示筛选项选中的列
        this.displayDynamicColumns = _toConsumableArray(this.Dynamic);
      } // 2. 确定目标天数（输入值优先）


      var targetDays = this.parsedDays.length > 0 ? this.parsedDays.map(String) : this.Dynamic.map(function (item) {
        return item.prop.replace('rem', '');
      }); // 3. 构建表格数据（严格按目标天数处理）

      var _loop = function _loop(k) {
        _this6.dates.push(k);

        var d = {
          date: k,
          register_num: res.data.other.register_num[k] || 0
        };
        var o = {
          name: k,
          type: "line",
          data: [],
          smooth: true
        }; // 只处理目标天数的数据

        targetDays.forEach(function (day) {
          var value = res.data.data[k][day] || 0;
          d["rem".concat(day)] = _this6.zhuan([value])[0];
          o.data.push(d["rem".concat(day)]);
        });

        _this6.series.push(o);

        _this6.tableData.push(d);
      };

      for (var k in res.data.data) {
        _loop(k);
      } // 4. 处理总计行


      var total = {
        date: this.$t('weightedAverageRetention'),
        register_num: res.data.register_sum || 0
      };
      targetDays.forEach(function (day) {
        total["rem".concat(day)] = _this6.zhuan([res.data.avgData[day] || 0])[0];
      });
      this.tableData.push(total); // 保存筛选项缓存（只存选中状态，不改变）

      this.saveScreenToCache(); // 更新图表

      this.getechart();
      this.$nextTick(function () {
        _this6.getTableRight();
      });
    },
    // 更新筛选项选中的列（Dynamic），不影响输入框
    screenControls: function screenControls() {
      var _this7 = this;

      var list = [];
      this.PrimitiveDy.forEach(function (item) {
        _this7.screen.forEach(function (citem) {
          if (item.prop == citem) {
            list.push(item);
          }
        });
      });
      setTimeout(function () {
        _this7.Dynamic = list; // 筛选项变化时保存缓存（只存选中状态）

        _this7.saveScreenToCache();
      }, 50);
    },
    zhuan: function zhuan(list) {
      var n = [];
      list.forEach(function (item) {
        n.push(item.length > 0 ? Number(item.substr(0, item.length - 1)) : 0);
      });
      return n;
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("serverRoleEchart");
      if (!chartDom) return;
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: this.$t('accountRetentionRate')
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: this.dates,
          width: "80%"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          // 图表X轴显示最终展示的列
          data: this.displayDynamicColumns.map(function (item) {
            return item.label;
          })
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100
        },
        series: this.series
      };
      option && myChart.setOption(option, true); // 窗口自适应

      window.addEventListener('resize', function () {
        return myChart.resize();
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('dateSlashDate'),
        prop: "date"
      }, {
        label: this.$t('newRoleSlashDnu'),
        prop: "register_num"
      }].concat(_toConsumableArray(this.displayDynamicColumns));
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.displayDynamicColumns.forEach(function (item) {
        data.forEach(function (i) {
          i[item.prop] = i[item.prop] + "%";
        });
      });
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    },
    gotoDetailList: function gotoDetailList(row, props) {
      console.log("row==", row, props);
      var date = row.date;
      var retainDay = props.replace('rem', '');
      var _this$searchData = this.searchData,
          game_id = _this$searchData.game_id,
          env_id = _this$searchData.env_id,
          special_product_id = _this$searchData.special_product_id,
          server_id = _this$searchData.server_id,
          is_roll = _this$searchData.is_roll;
      var query = {
        key: 'serverRoleRetain',
        register_date: date,
        retain_day: retainDay,
        game_id: game_id,
        env_id: env_id,
        special_product_id: special_product_id,
        server_id: server_id,
        is_roll: is_roll
      };
      this.$refs.retainAllList.init(query);
    }
  }
};